import DashboardHeader from '../common/dashboardHeader';
import DashboardContent from '../dashboardContent';
import {Grid} from '@material-ui/core';


function Dashboard(props){
    return(
        <Grid container xs="12" md="12" direction="row">
            <DashboardHeader Briefs={props.Briefs}/>
            <DashboardContent Briefs={props.Briefs}/>           
        </Grid>
    );

}

export default Dashboard;